import Animation from './Animation';
import { play } from '../../../SoundManager';

export default class Buy extends Animation {

	constructor (master) {

		super(master, 0);
		this.loadAudio("shop");
	}

	run () {

	}
}